// ** Styled Components
import CaretDown from "components/icons/CaretDown";
import CaretUp from "components/icons/CaretUp";
import Block from "../Block";
import { StyledSelectorLabel } from "../DropdownSelectors/components/SelectorLabel.styled.";
import { StyledSelectorLabelWrapper } from "./styles/SelectorLabelWrapper.styled";
import { SelectorSectionStyled } from "./styles/SelectorSection.styled";
import { SelectorWrapperStyled } from "./styles/SelectorWrapper.styled";

// #####################################################

const Section = ({
	children,
	layerSide,
	isOpen,
	isPhone,
	label,
	withCaret = true,
	rowGap = "3px",
	customCaretMargin,
	...props
}) => {
	return (
		<SelectorSectionStyled isOpen={isOpen} layerSide={layerSide} {...props}>
			<Block
				flex
				column
				full
				fullHeight={layerSide !== "top" && isOpen}
				style={{ rowGap }}
			>
				{(layerSide !== "top" ||
					(layerSide === "top" && !isOpen) ||
					isPhone) && (
					<Block>
						<StyledSelectorLabelWrapper>
							<StyledSelectorLabel>{label}</StyledSelectorLabel>
						</StyledSelectorLabelWrapper>
					</Block>
				)}
				{children}
			</Block>
			{withCaret && (
				<Block flex>
					<Block
						ml={2}
						style={{ marginTop: customCaretMargin || null }}
					>
						{isOpen ? <CaretUp /> : <CaretDown />}
					</Block>
				</Block>
			)}
		</SelectorSectionStyled>
	);
};

const Selector = ({ isOpen, layerSide, children, ...rest }) => {
	return (
		<SelectorWrapperStyled
			className="SelectorWrapperStyled"
			{...rest}
			isOpen={isOpen}
			layerSide={layerSide}
			innerRef={rest.innerRef}
		>
			{children}
		</SelectorWrapperStyled>
	);
};

// #####################################################

Selector.Section = Section;

export default Selector;

// #####################################################
